<script>
export default {
    name: "ConfirmCancelInvoice",
data(){
  return {
 cancelinvoicedata:{
  invoiceNo:"",
  userName:this.$root.username,
  comment:"Cancel Unposted Invoice",

}
  }
},
    props: {
        invoiceNo: String,
        showModal: {
            type: Boolean,
            default: false
        }
    },

    // computed: {

    //     invoicePostDetails () {

    //         return {

    //           InvoiceNo: this.invoiceDetails.invoiceNo,
    //           SupplierID: this.invoiceDetails.supplierID,
    //           DatePosted: this.invoiceDetails.sysDate,
    //           UserName: this.invoiceDetails.userName
    //         };
    //   }
    // },

    methods: {

       CancelInvoice () {

            this.$root.loading = true;
this.cancelinvoicedata.invoiceNo=this.invoiceNo;
            this.$accountsHttp.post('SupplierInvoice/ReverseSupplierInvoice',this.cancelinvoicedata)
              .then(response => {
                this.$root.loading = false;
                this.$emit(`closeModal`, true);
                this.$emit(`refresh`, true);
                window.Swal.fire({ text: response.data, type: 'success' });
             
            }).catch(() => this.$root.loading = false);
      },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 w-1/2">
      <template v-slot:title>
        <h5 class="font-semibold text-sm">Confirm Reverse Invoice</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-4">
          <h4 class="font-bold text-sm text-blue text-center">Invoice No: {{ invoiceNo  }}</h4>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-8" @click="$emit(`closeModal`)">Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="CancelInvoice">
            <i class="fa fa-check"></i> Confirm Reverse Invoice
            </button>
      </template>
    </tail-modal>
</template>
